/* DMM CRO PDP, 2026-10-29, revised 2026-11-04. Vanilla JS for the jewelry PDP (layout dw-native-jewelry loads no Horizon framework).
   1. Sticky Add to bag at 749px and narrower: shown once the native [data-nj-add] button has scrolled above the
      viewport; hidden while that button is in view or below, near the footer, or when the button is disabled.
      Its click is forwarded to the native submit button, so the same native product form submits (the jewelry
      cart drawer handles that submit exactly as it does for the main button).
   2. Keeps the payment-terms form's variant id in step with the native variant picker (multi-variant pieces). */
(() => {
  'use strict';
  const root = document.querySelector('[data-nj-product]');
  if (!root) return;
  const form = root.querySelector('[data-nj-form]');
  const main = form && form.querySelector('[data-nj-add]');
  const picker = form && form.querySelector('select[data-nj-variant]');
  const termsId = root.querySelector('[data-dw-cro-terms] input[name="id"]');
  if (picker && termsId) {
    picker.addEventListener('change', () => {
      termsId.value = picker.value;
      termsId.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }
  const bar = document.querySelector('[data-dw-cro-sticky]');
  if (!bar || !main || !('IntersectionObserver' in window)) return;
  const button = bar.querySelector('[data-dw-cro-sticky-add]');
  const price = bar.querySelector('[data-dw-cro-sticky-price]');
  const mainPrice = root.querySelector('[data-nj-price]');
  const footer = document.querySelector('footer');
  const narrow = window.matchMedia('(max-width: 749px)');
  let past = false;
  let nearFooter = false;
  document.body.appendChild(bar);
  bar.hidden = false;
  function sync() {
    const show = narrow.matches && past && !nearFooter && !main.disabled;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    bar.inert = !show;
    if (show && price && mainPrice) price.textContent = mainPrice.textContent.trim();
  }
  new IntersectionObserver(entries => {
    const e = entries[entries.length - 1];
    past = !e.isIntersecting && e.boundingClientRect.bottom <= 0;
    sync();
  }).observe(main);
  if (footer) {
    new IntersectionObserver(entries => {
      nearFooter = entries[entries.length - 1].isIntersecting;
      sync();
    }, {rootMargin: '0px 0px 120px 0px'}).observe(footer);
  }
  if (narrow.addEventListener) narrow.addEventListener('change', sync);
  else if (narrow.addListener) narrow.addListener(sync);
  form.addEventListener('change', () => setTimeout(sync, 0));
  button.addEventListener('click', () => { if (!main.disabled) main.click(); });
  sync();
})();
